import * as m from '@/paraglide/messages';
import oneNote from '@listening/assets/astro/images/new-design-25/features-page/notes.png';

export function OneNote() {
  return (
    <section className='relative mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8'>
      <div className='relative mx-auto max-w-[1600px] overflow-hidden rounded-[48px] border border-gray-100/20 bg-white px-4 py-16 shadow-[0_0_44px_-15px_rgba(0,0,0,0.1)] sm:px-6 lg:px-8'>
        <div className='grid gap-8 lg:grid-cols-2 lg:gap-12'>
          {/* <!-- Content Column --> */}
          <div className='flex flex-col justify-center space-y-6'>
            <h2 className='mb-12 max-w-2xl text-4xl leading-tight font-bold tracking-tight text-gray-900 sm:text-5xl md:text-8xl'>
              {m.features_onenote_title()}
            </h2>
            <div className='space-y-10 text-lg text-gray-600'>
              <p className='max-w-lg'>{m.features_onenote_description_1()}</p>
              <p className='max-w-lg'>{m.features_onenote_description_2()}</p>
            </div>
          </div>

          {/* <!-- Image Column --> */}
          <div className='relative flex items-center justify-center'>
            <img
              alt='OneNote feature screenshot'
              className='w-full max-w-[500px]'
              height={500}
              src={oneNote}
              width={500}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
